import {
  IFilterForm,
  IFilterDropdown,
  TTerminal,
} from "./overagesFilterFormActions";
import NOTIFICATION_TYPE from "./NotificationType";
import { APP } from "../constants";
import { GridPaginationModel } from "@mui/x-data-grid";
import { IUserPermissions } from "../models/user";

/**
 * The type definition of our app's central state (Redux State)
 */

//// define property
export interface AppState {
  readonly isLoading: boolean;
  readonly isLoggedIn: boolean;
  readonly isFormValueChanged: boolean;
  readonly _persist: any;
  readonly tabPosition: number;
  readonly userPermissions: IUserPermissions;
  readonly activeTerminal: TTerminal;
  readonly terminalMaster: TTerminal[];
  readonly overagesFilterDateData: IFilterDropdown[];
  readonly commodityMasterData: IFilterDropdown[];
  readonly packageOptionMasterData: IFilterDropdown[];
  readonly exceptionCodeMasterData: string[];
  readonly shortageExceptionCodeData: string[];
  readonly damageExceptionCodeData: string[];
  readonly onHandDeliveryExceptionCodeData: string[];
  readonly misdeliveryExceptionCodeData: string[];
  readonly docTypeMaster: string[];
  readonly allExceptionCodeData: string[];
  readonly valueRangeMasterData: IFilterDropdown[];
  readonly investigationStatusMasterData: IFilterDropdown[];
  readonly shortageStatusMasterData: IFilterDropdown[];
  readonly myAssignmentStatusMasterData: IFilterDropdown[];
  readonly damageStatusMasterData: IFilterDropdown[];
  readonly onHandDeliveryStatusMasterData: IFilterDropdown[];
  readonly misdeliveryStatusMasterData: IFilterDropdown[];
  readonly notificationType: NOTIFICATION_TYPE;
  readonly message: string;
  readonly notificationTime: string;
  readonly notificationChange: string;
  readonly overageSortObjectData?: any;
  readonly overageListPageObject: GridPaginationModel;
  readonly myAssignmentSortObjectData?: any;
  readonly myAssignmentPageObject: GridPaginationModel;
  readonly shortagesSortObject?: any;
  readonly damagesSortObject?: any;
  readonly onHandDeliverySortObject?: any;
  readonly misdeliverySortObject?: any;
  readonly shortagesPageObject: GridPaginationModel;
  readonly damagesPageObject: GridPaginationModel;
  readonly onHandDeliveryPageObject: GridPaginationModel;
  readonly misdeliveryPageObject: GridPaginationModel;
  readonly overagesFilterForm: IFilterForm;
  readonly myAssignmentsFilterForm: IFilterForm;
  readonly exceptionSearchFilterForm: IFilterForm;
  readonly shortagesFilterForm: IFilterForm;
  readonly damagesFilterForm: IFilterForm;
  readonly onHandDeliveryFilterForm: IFilterForm;
  readonly misdeliveryFilterForm: IFilterForm;
  readonly searchExceptionPageObject: GridPaginationModel;
  readonly searchExceptionSortObject: any;
}

const baseFilterForm = {
  search: "",
  date: "",
  toDate: "",
  fromDate: "",
  origin: [],
  destination: [],
  reporting: [],
  osdType: [],
  commodityType: [],
  description: "",
  shipperName: "",
  consigneeName: "",
  proNumber: "",
  od400ProNumber: "",
  osdNumber: "",
  values: [],
  status: [],
  entryUser: null,
};
const withAssignedBy = {
  ...baseFilterForm,
  assignedBy: null,
};

const withAssignedTo = {
  ...baseFilterForm,
  assignedTo: null,
};

//// set Initial state of the property
export const DEFAULT_APP_STATE: AppState = {
  isLoading: false,
  isFormValueChanged: false,
  tabPosition: 1,
  userPermissions: {
    overages: {
      enabledFor: ["SELF"],
      investigationAndFollowUp: {
        enabledFor: ["SELF"],
        completion: {
          enabledFor: ["SELF"],
        },
      },
    },
    shortages: {
      enabledFor: ["SELF"],
      investigationAndFollowUp: {
        enabledFor: ["SELF"],
        completion: {
          enabledFor: ["SELF"],
        },
      },
    },
    onHandDeliveries: {
      enabledFor: ["SELF"],
      investigationAndFollowUp: {
        enabledFor: ["SELF"],
        completion: {
          enabledFor: ["SELF"],
        },
      },
    },
    damages: {
      enabledFor: ["SELF"],
      investigationAndFollowUp: {
        enabledFor: ["SELF"],
        completion: {
          enabledFor: ["SELF"],
        },
      },
    },
    misDeliveries: {
      enabledFor: ["SELF"],
      bol: {
        enabledFor: ["SELF"],
        submition: {
          enabledFor: ["SELF"],
        },
        hazmatApproval: {
          enabledFor: [],
        },
      },
      investigationAndFollowUp: {
        enabledFor: ["SELF"],
        completion: {
          enabledFor: ["SELF"],
        },
      },
    },
  },
  isLoggedIn: false,
  activeTerminal: { terminalId: "", region: null },
  terminalMaster: [],
  docTypeMaster: [],
  overagesFilterDateData: [],
  commodityMasterData: [],
  packageOptionMasterData: [],
  exceptionCodeMasterData: [],
  shortageExceptionCodeData: [],
  damageExceptionCodeData: [],
  onHandDeliveryExceptionCodeData: [],
  misdeliveryExceptionCodeData: [],
  allExceptionCodeData: [],
  overageSortObjectData: APP.sortModel,
  overageListPageObject: APP.pageObject,
  myAssignmentSortObjectData: APP.sortModel,
  myAssignmentPageObject: APP.pageObject,
  shortagesSortObject: APP.sortModel,
  damagesSortObject: APP.sortModel,
  onHandDeliverySortObject: APP.sortModel,
  misdeliverySortObject: APP.sortModel,
  searchExceptionPageObject: APP.pageObject,
  searchExceptionSortObject: APP.sortModel,
  shortagesPageObject: APP.pageObject,
  damagesPageObject: APP.pageObject,
  onHandDeliveryPageObject: APP.pageObject,
  misdeliveryPageObject: APP.pageObject,
  valueRangeMasterData: [],
  investigationStatusMasterData: [],
  shortageStatusMasterData: [],
  myAssignmentStatusMasterData: [],
  damageStatusMasterData: [],
  onHandDeliveryStatusMasterData: [],
  misdeliveryStatusMasterData: [],
  overagesFilterForm: {
    ...withAssignedTo,
  },
  exceptionSearchFilterForm: {
    ...withAssignedTo,
  },
  myAssignmentsFilterForm: {
    ...withAssignedBy,
  },
  shortagesFilterForm: {
    ...withAssignedBy,
  },
  damagesFilterForm: {
    ...withAssignedBy,
  },
  onHandDeliveryFilterForm: {
    ...withAssignedBy,
  },
  misdeliveryFilterForm: {
    ...withAssignedBy,
  },
  message: "",
  notificationTime: "",
  notificationChange: "",
  // defauld field //
  _persist: undefined,
  notificationType: NOTIFICATION_TYPE.SUCCESS,
};
